export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does F&T Renovations serve?",
    a: "We're based in Lawrenceville, GA and work across metro Atlanta — Alpharetta, Johns Creek, Roswell, Buford, Suwanee, Flowery Branch, Duluth, Peachtree Corners, Lilburn, Norcross and Buckhead. If you're near that footprint and not listed, call us anyway and we'll tell you straight whether we can get to you.",
  },
  {
    q: "What services do you offer?",
    a: "Painting, bathroom remodeling, flooring, plumbing, electrical, Sheetrock and drywall, tile work, decks, and basement finishing. Because we self-perform all of it, a multi-trade project like a bathroom or a basement runs on one schedule with one crew instead of five separate subcontractors.",
  },
  {
    q: "How much does a project cost?",
    a: "Every job is priced individually — it depends on the size of the space, the condition of what's already there, and the materials you choose. We come out, look at the actual space, and give you a written estimate with the scope spelled out. Estimates are free and there's no obligation.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Yes. Returning customers, and friends of past customers, get 10% off any job over $2,000. Just mention it when you request your estimate.",
  },
  {
    q: "How long has F&T Renovations been in business?",
    a: "Six years of hands-on remodeling and painting experience. We started in painting and grew into full remodeling as customers kept asking us to handle the rest of the job too.",
  },
  {
    q: "What are your hours?",
    a: "Monday through Saturday, 8:00 AM to 5:00 PM. We're closed Sundays. Call or text (678) 431-1203 during business hours and you'll reach us directly.",
  },
  {
    q: "Do you handle both the demo and the finish work?",
    a: "Yes — start to finish. On a bathroom that means demo, plumbing, electrical, waterproofing, tile, drywall, trim and paint. You're not left finding someone else to close the walls back up or repaint after we're done.",
  },
  {
    q: "How do I get an estimate?",
    a: "Call or text (678) 431-1203, email fandtrenovations@gmail.com, or send us your details through the estimate form on this site. We'll set up a walkthrough, look at the space, and follow up with a written price.",
  },
];
